import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'loyaltic-dev-navigation',
    templateUrl: './dev-navigation.component.html',
    styleUrls: ['./dev-navigation.component.scss'],
    standalone: false
})
export class DevNavigationComponent implements OnInit {
  playType = 'playWithReceipt';

  isParticipateWithEmail = false;
  isParticipateWithEmailAndReceipt = false;
  isParticipateWithPhone = false;
  isParticipateWithPhoneAndReceipt = false;

  
  constructor() { }

  ngOnInit() {
  }
  participateWithEmail(){
    this.resetSelectedOption();
    this.isParticipateWithEmail = true;
  }
  participateWithEmailAndReceipt(){
    this.resetSelectedOption();
    this.isParticipateWithEmailAndReceipt = true;
  }
  participateWithPhone(){
    this.resetSelectedOption();
    this.isParticipateWithPhone = true;
  }
  participateWithPhoneAndReceipt(){
    this.resetSelectedOption();
    this.isParticipateWithPhoneAndReceipt = true;
  }

  resetSelectedOption() {
    this.isParticipateWithEmail = false;
    this.isParticipateWithEmailAndReceipt = false;
    this.isParticipateWithPhone = false;
    this.isParticipateWithPhoneAndReceipt = false;
  }
}
